import { Chip } from "@mui/material";
import { translate } from "../../i18n/customI18nProvider";

const QuickFilter = ({ label }) => {
    return <Chip style={{margin: 8, marginLeft: 0}} label={translate(label)} />;
};

export default QuickFilter;